(function() {
  'use strict';
  
  function initBundle(blockElement) {
    const blockId = blockElement.dataset.blockId;
    const bundleData = window.bundleData[blockId];
    
    if (!bundleData) {
      console.error('Bundle data not found for block:', blockId);
      return;
    }
    
    let selectedVariantId = bundleData.selectedVariantId;
    let selectedVariantPrice = bundleData.selectedVariantPrice;
    let addonVariantId = bundleData.addonVariantId;
    let addonPrice = bundleData.addonPrice;
    
    const variantOptions = blockElement.querySelectorAll('.bundle-variant-option');
    const addonCheckbox = blockElement.querySelector('#addon-checkbox-' + blockId);
    const addonContainer = blockElement.querySelector('#bundle-addon-' + blockId);
    const mainImage = blockElement.querySelector('#bundle-main-image-' + blockId);
    const mainPriceEl = blockElement.querySelector('#bundle-main-price-' + blockId);

    // Flag pour éviter la double exécution click + submit
    let isHandling = false;

    function forceVariantInForm(variantId) {
      const variantInput = document.querySelector('input.product-variant-id');
      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));       
      }
    }

    function handleAddToCart(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      if (isHandling) return;
      isHandling = true;
      setTimeout(function() { isHandling = false; }, 500);

      forceVariantInForm(selectedVariantId);

      const items = [{ id: selectedVariantId, quantity: 1 }];

      if (addonCheckbox && addonCheckbox.checked && addonVariantId) {
        items.push({ id: addonVariantId, quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) { return response.json(); })
      .then(function() { window.location.href = '/cart'; })
      .catch(function(error) {
        console.error('Erreur ajout au panier:', error);
        isHandling = false;
      });
    }
    
    variantOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        variantOptions.forEach(function(opt) {
          opt.classList.remove('selected');
        });
        
        this.classList.add('selected');
        
        selectedVariantId = parseInt(this.dataset.variantId);
        selectedVariantPrice = parseInt(this.dataset.variantPrice);
        
        if (mainImage) {
          const variantImg = this.querySelector('img');
          if (variantImg && variantImg.src) {
            mainImage.src = variantImg.src;
          }
        }
        
        if (mainPriceEl) {
          mainPriceEl.textContent = formatMoney(selectedVariantPrice);
        }
        
        const comparePriceEl = blockElement.querySelector('.bundle-price-compare');
        const comparePrice = this.dataset.variantComparePrice;
        if (comparePriceEl && comparePrice && parseInt(comparePrice) > selectedVariantPrice) {
          comparePriceEl.textContent = formatMoney(parseInt(comparePrice));
          comparePriceEl.style.display = 'block';
        } else if (comparePriceEl) {
          comparePriceEl.style.display = 'none';
        }

        updateTotalPrice(true);
      });
    });
    
    if (addonContainer) {
      addonContainer.addEventListener('click', function(e) {
        if (e.target.type !== 'checkbox') {
          addonCheckbox.checked = !addonCheckbox.checked;
          updateTotalPrice(true);
        }
      });
      
      if (addonCheckbox) {
        addonCheckbox.addEventListener('change', function() {
          updateTotalPrice(true);
        });
      }
    }
    
    function updateTotalPrice(fromUserInteraction) {
      let totalPrice = selectedVariantPrice;
      
      if (addonCheckbox && addonCheckbox.checked) {
        totalPrice += addonPrice;
      }
      
      if (fromUserInteraction) {
        updateDawnMainPrice(totalPrice, selectedVariantId);
      }
    }
    
    function updateDawnMainPrice(totalPrice, variantId) {
      const regularPrice = document.querySelector('.price__regular .price-item--regular');
      const salePrice = document.querySelector('.price__sale .price-item--sale');
      const comparePriceEl = document.querySelector('.price__sale s.price-item--regular');

      const selectedOption = blockElement.querySelector('.bundle-variant-option.selected');
      const comparePrice = selectedOption ? parseInt(selectedOption.dataset.variantComparePrice) : null;

      // On compare comparePrice avec selectedVariantPrice (sans addon)
      // pour ne pas masquer le prix barré quand l'addon est coché
      if (comparePrice && comparePrice > selectedVariantPrice) {
        if (comparePriceEl) comparePriceEl.textContent = formatMoney(comparePrice);
        if (salePrice) salePrice.textContent = formatMoney(totalPrice);
        if (regularPrice) regularPrice.textContent = formatMoney(totalPrice);
      } else {
        if (regularPrice) regularPrice.textContent = formatMoney(totalPrice);
        if (comparePriceEl) comparePriceEl.textContent = '';
      }

      forceVariantInForm(variantId);

      if (window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: {
              id: variantId,
              price: totalPrice
            }
          }
        }));
      }
    }
    
    // Format automatique basé sur la devise Shopify du magasin
    // Détecte le symbole et la position (avant ou après) depuis le prix formaté Shopify
    function formatMoney(cents) {
      const formatted = bundleData.selectedVariantPriceFormatted;
      const amount = (cents / 100).toFixed(2);
      
      // Détecte si le symbole est avant ou après le montant
      const symbolBefore = formatted.match(/^([^\d]+)/);
      const symbolAfter = formatted.match(/([^\d.,\s]+)\s*$/);
      
      if (symbolBefore) {
        return symbolBefore[1] + amount;
      } else if (symbolAfter) {
        return amount + '\u00a0' + symbolAfter[1];
      }
      
      return amount;
    }
    
    // Desktop : click en phase de capture (avant Dawn)
    const submitButton = document.querySelector('[id^="ProductSubmitButton"]');
    if (submitButton) {
      submitButton.addEventListener('click', handleAddToCart, true);
      submitButton.addEventListener('touchend', handleAddToCart, true);
    }

    // Fallback si le bouton n'est pas trouvé
    const addToCartForm = document.querySelector('form[action="/cart/add"]');
    if (addToCartForm && !submitButton) {
      addToCartForm.addEventListener('submit', handleAddToCart, true);
    }
    
    if (selectedVariantId) {
      forceVariantInForm(selectedVariantId);
    }
  }
  
  function initAllBundles() {
    const bundleBlocks = document.querySelectorAll('.product-bundle-block');
    bundleBlocks.forEach(function(block) {
      initBundle(block);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBundles);
  } else {
    initAllBundles();
  }
  
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllBundles);
  }
})();
